import { ReactNode } from 'react';
import OrderFix from '../components/pages/order/OrderFix';
import OrderList from '../components/pages/order/OrderList';
import OrderRegistration from '../components/pages/order/OrderRegistration';
import OrderSingle from '../components/pages/order/OrderSingle';
import OrderListDetail from '../components/pages/order/OrderListDetail';
import CS from '../components/pages/cs/CS';
import Product from '../components/pages/product/Product';
import Statistics from '../components/pages/statistic/Statistic';
import ProductStatistics from '../components/pages/statistic/ProductStatistics';
import MypageProfile from '../components/pages/mypage/MypageProfile';
import ProductDetail from '../components/pages/product/ProductDetail';
import ProductCreate from '../components/pages/product/ProductCreate';
import ProductUpdate from '../components/pages/product/ProductUpdate';
import Prompt from '../components/pages/prompt/Prompt';
import PromptCUD from '../components/pages/prompt/PromptCUD';
import Franchise from '../components/pages/franchise/Franchise';
import FranchiseUpdate from '../components/pages/franchise/FranchiseUpdate';
import BokbiHistoryList from '../components/pages/bokbi/BokbiHistoryList';
import BokbiStatistics from '../components/pages/bokbi/BokbiStatistics';
import PurchaseOrderList from '../components/pages/bokbi/PurchaseOrderList';
import CodeManagementPage from '../components/pages/fortuneLab/CodeManagementPage';
import PerformancePage from '../components/pages/fortuneLab/PerformancePage';
import StatisticsPage from '../components/pages/fortuneLab/StatisticsPage';
import CouponSendPage from '../components/pages/fortuneLab/CouponSendPage';
import ProductThumbnail from '../components/pages/product/ProductThumbnail';
import ProductImage from "../components/pages/product/ProductImage";
import ProductImageUpdate from "../components/pages/product/ProductImageUpdate";
import EmailTemplateEditor from '../components/pages/email/EmailTemplateEditor';
import SenderProfilePage from '../components/pages/bizmsg/SenderProfilePage';
import BokbiDepositContent from "../components/pages/bokbi/BokbiDepositContent";
import ConsultOrderRegistration from '../components/pages/consult-order/ConsultOrderRegistration';
import ConsultOrderList from '../components/pages/consult-order/ConsultOrderList';
import ConsultOrderFix from '../components/pages/consult-order/ConsultOrderFix';
import ConsultOrderDetail from '../components/pages/consult-order/ConsultOrderDetail';
import ConsultManagementPage from "../components/pages/randing/ConsultManagementPage";
import ConsultRequestPage from "../components/pages/randing/ConsultRequestPage";
import PurchaseLandingManagementPage from "../components/pages/purchaseLanding/PurchaseLandingManagementPage";
import PurchaseLandingRequestPage from "../components/pages/purchaseLanding/PurchaseLandingRequestPage";

// 각 라우트의 구조 타입 정의

/** 사용자 역할 타입 */
type UserRole = 'ROLE_USER' | 'ROLE_ADMIN' | 'ROLE_CS' | 'ROLE_TRACKING' | 'ROLE_JOINED' | 'ROLE_MARKETING';

interface RouteConfig {
  menu: string;
  sid: string;
  role: UserRole[];
  component: ReactNode;
}

// 전체 라우트 객체의 타입 정의
type CustomRoutes = Record<string, RouteConfig>;

/** 모든 역할을 간편하게 표현하기 위한 상수 (선택사항) */
const ALL_ROLES: UserRole[] = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_CS', 'ROLE_MARKETING'];
const ALL_ROLES_EXCEPT_JOINED: UserRole[] = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_CS', 'ROLE_TRACKING', 'ROLE_MARKETING'];

export const customRoutes: CustomRoutes = {

  // 카카오 채널 연동
  '/bizmsg/sender': {
    menu: '카카오 채널 연동',
    sid: 'BZ-100',
    role: ['ROLE_USER', 'ROLE_MARKETING'],
    component: <SenderProfilePage />,
  },

  // 주문
  '/order/create': {
    menu: '주문 등록',
    sid: 'REG-100',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <OrderRegistration />,
  },
  '/order/single': {
    menu: '단건 주문',
    sid: 'REG-150',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <OrderSingle />,
  },
  '/order/list': {
    menu: '주문 대기',
    sid: 'REG-200',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <OrderList />,
  },
  '/order/list/:orderId': {
    menu: '주문 대기 상세',
    sid: 'REG-201',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <OrderListDetail />,
  },
  '/order/fix': {
    menu: '주문 확정',
    sid: 'REG-300',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <OrderFix />,
  },
  '/order/fix/:orderFixId': {
    menu: '주문 확정 상세',
    sid: 'REG-301',
    role: ['ROLE_ADMIN', 'ROLE_CS', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <OrderListDetail />,
  },

  // 상담 주문
  '/consult-order/create': {
    menu: '상담 주문 등록',
    sid: 'CON-100',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <ConsultOrderRegistration />,
  },
  '/consult-order/list': {
    menu: '상담 주문 대기',
    sid: 'CON-200',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <ConsultOrderList />,
  },
  '/consult-order/list/:orderId': {
    menu: '상담 주문 상세',
    sid: 'CON-201',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <ConsultOrderDetail />,
  },
  '/consult-order/fix': {
    menu: '상담 주문 확정',
    sid: 'CON-300',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <ConsultOrderFix />,
  },
  '/consult-order/fix/:orderId': {
    menu: '상담 주문 확정 상세',
    sid: 'CON-301',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <ConsultOrderDetail />,
  },
  '/randing/compain': {
    menu: '상담 랜딩페이지',
        sid: 'CON-400',
        role: ALL_ROLES_EXCEPT_JOINED,
        component: <ConsultManagementPage />
  },
  '/randing/request': {
    menu: '상담 신청내역',
    sid: 'CON-500',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <ConsultRequestPage />
  },

  // 구매 랜딩페이지
  '/purchase-landing/management': {
    menu: '구매 랜딩페이지',
    sid: 'PL-100',
    role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_CS', 'ROLE_MARKETING'],
    component: <PurchaseLandingManagementPage />
  },
  '/purchase-landing/request': {
    menu: '구매 신청내역',
    sid: 'PL-200',
    role: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_CS', 'ROLE_MARKETING'],
    component: <PurchaseLandingRequestPage />
  },

  // CS
  '/cs': {
    menu: 'CS',
    sid: 'CS-100',
    role: ALL_ROLES_EXCEPT_JOINED,
    component: <CS />,
  },

  // 프롬프트
  '/prompt': {
    menu: '프롬프트',
    sid: 'PRM-100',
    role: ['ROLE_ADMIN'],
    component: <Prompt />,
  },
  '/prompt/create': {
    menu: '프롬프트 등록',
    sid: 'PRM-200',
    role: ['ROLE_ADMIN'],
    component: <PromptCUD mode="C" />,
  },
  '/prompt/:promptId': {
    menu: '프롬프트 상세',
    sid: 'PRM-101',
    role: ['ROLE_ADMIN'],
    component: <PromptCUD mode="U" />,
  },

  // 상품
  '/product': {
    menu: '상품',
    sid: 'PRD-100',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <Product />,
  },
  '/product/list': {
    menu: '상품 목록',
    sid: 'PRD-100',
    role: ['ROLE_ADMIN'],
    component: <Product />,
  },
  '/product/create': {
    menu: '상품 등록',
    sid: 'PRD-200',
    role: ['ROLE_ADMIN'],
    component: <ProductCreate />,
  },
  '/product/update/:id': {
    menu: '상품 수정',
    sid: 'PRD-300',
    role: ['ROLE_ADMIN'],
    component: <ProductUpdate />,
  },
  '/product/:productId': {
    menu: '상품 상세',
    sid: 'PRD-101',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <ProductDetail />,
  },
  '/product/thumbnail': {
    menu: '상품 확인',
    sid: 'PRD-102',
    role: ['ROLE_ADMIN'],
    component: <ProductThumbnail />,
  },
  '/product-image/:productId/:franchiseId': {
    menu: '상품 표지 이미지 수정',
    sid: 'PRD-103',
    role: ['ROLE_ADMIN'],
    component: <ProductImage />,
  },
  '/update/product-image/:productId': {
    menu: '상품 이미지 수정',
    sid: 'PRD-104',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <ProductImageUpdate />,
  },

  // 통계
  '/statistics/franchise': {
    menu: '가맹점별 통계',
    sid: 'STT-100',
    role: ['ROLE_ADMIN'],
    component: <Statistics />,
  },
  '/statistics/product': {
    menu: '상품별 통계',
    sid: 'STT-200',
    role: ['ROLE_ADMIN'],
    component: <ProductStatistics />
  },

  // 내 정보
  '/mypage/profile': {
    menu: '프로필',
    sid: 'MYP-100',
    role: ['ROLE_USER', 'ROLE_MARKETING'],
    component: <MypageProfile />,
  },

  // 가맹점
  '/franchise': {
    menu: '가맹점',
    sid: 'FRN-100',
    role: ['ROLE_ADMIN'],
    component: <Franchise />,
  },
  '/franchise/update/:id': {
    menu: '가맹점 상세',
    sid: 'FRN-200',
    role: ['ROLE_ADMIN'],
    component: <FranchiseUpdate />,
  },

  // 복비 내역
  '/bokbi/bokbi-history': {
    menu: '복비 내역',
    sid: 'BHS-100',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <BokbiHistoryList />,
  },
  '/bokbi/bokbi-statistics': {
    menu: '복비 통계',
    sid: 'BHS-200',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <BokbiStatistics />,
  },
  '/bokbi/purchase-order': {
    menu: '입금 대기 관리',
    sid: 'BHS-300',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <PurchaseOrderList />,
  },
  '/bokbi/purchase': {
    menu: '복비 입금 신청',
    sid: 'BHS-400',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <BokbiDepositContent />,
  },

  // Today Saju
  '/today-saju/codes': {
    menu: '캠페인 생성/조회',
    sid: 'TS-100',
    role: ['ROLE_ADMIN', 'ROLE_TRACKING', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <CodeManagementPage />,
  },
  '/today-saju/performance': {
    menu: '신청 내역 조회',
    sid: 'TS-200',
    role: ['ROLE_ADMIN', 'ROLE_TRACKING', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <PerformancePage />,
  },
  '/today-saju/statistics': {
    menu: '오늘의 운세 캠페인 통계',
    sid: 'TS-300',
    role: ['ROLE_ADMIN', 'ROLE_TRACKING', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <StatisticsPage />,
  },
  '/today-saju/coupon-send': {
    menu: '쿠폰 발송',
    sid: 'TS-400',
    role: ['ROLE_ADMIN', 'ROLE_TRACKING', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <CouponSendPage />,
  },

  // 이메일 템플릿 관리
  '/email-template': {
    menu: '이메일 템플릿 관리',
    sid: 'TDL-600',
    role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_MARKETING'],
    component: <EmailTemplateEditor />,
  },
};
